/**
 * Sectors scroller — scroll orizzontale con la rotella del mouse.
 *
 * Lo scroller "I Nostri Settori" (.sectors__scroller) ha overflow orizzontale
 * e `scroll-snap-type: x mandatory`. Trackpad e shift+rotella scrollano già in
 * orizzontale; con un mouse a sola rotella verticale, invece, la sezione non si
 * muove. Qui convertiamo il deltaY (scroll verticale) in scroll orizzontale.
 *
 * Nota UX: lo snap `mandatory` riaggancia alla card più vicina QUALSIASI
 * `scrollLeft` impostato via JS, azzerando i piccoli spostamenti della rotella
 * (a differenza dello scroll nativo del trackpad, che snappa solo a fine gesto).
 * Per replicare quel comportamento disattiviamo temporaneamente lo snap durante
 * lo scroll a rotella e lo ripristiniamo quando l'utente si ferma: così lo
 * scroll è libero e le card si agganciano comunque a riposo.
 */
(function () {
	'use strict';

	var scrollers = document.querySelectorAll('.sectors__scroller');
	if (!scrollers.length) {
		return;
	}

	// Normalizza il delta in pixel: deltaMode 1 = righe, 2 = pagine.
	function deltaToPixels(event) {
		if (event.deltaMode === 1) {
			return event.deltaY * 16;
		}
		if (event.deltaMode === 2) {
			return event.deltaY * window.innerHeight;
		}
		return event.deltaY;
	}

	Array.prototype.forEach.call(scrollers, function (scroller) {
		var restoreTimer = null;

		function restoreSnap() {
			// Rimuove l'override inline → torna in vigore lo snap del CSS, che
			// aggancia alla card più vicina alla posizione di riposo.
			scroller.style.removeProperty('scroll-snap-type');
		}

		scroller.addEventListener(
			'wheel',
			function (event) {
				// Solo scroll verticale (rotella): il trackpad orizzontale resta nativo.
				if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) {
					return;
				}

				var max = scroller.scrollWidth - scroller.clientWidth;
				if (max <= 0) {
					return; // nessun overflow orizzontale
				}

				var delta = deltaToPixels(event);

				// A fine corsa lascia scorrere normalmente la pagina.
				var atStart = scroller.scrollLeft <= 0 && delta < 0;
				var atEnd = scroller.scrollLeft >= max && delta > 0;
				if (atStart || atEnd) {
					return;
				}

				event.preventDefault();

				// Snap off durante il gesto, ripristino dopo la pausa.
				scroller.style.scrollSnapType = 'none';
				scroller.scrollLeft = Math.max(0, Math.min(max, scroller.scrollLeft + delta));

				window.clearTimeout(restoreTimer);
				restoreTimer = window.setTimeout(restoreSnap, 120);
			},
			{ passive: false }
		);
	});
})();
